
import React from 'react';
import { Recipe } from '@/types/recipe';
import { MealPlanWithDetails } from '@/types/mealPlan';
import { MealCompositionWithRecipes } from '@/types/mealComposition';
import { MealType } from '@/types/mealPlan';
import { MealNote } from '@/types/mealNote';
import MealPlannerTile from './MealPlannerTile';

interface DateCardProps {
  date: Date;
  mealPlans?: MealPlanWithDetails[];
  mealNotes?: MealNote[];
  recipes: Recipe[];
  compositions?: MealCompositionWithRecipes[];
  isLoading: boolean;
  isSubmitting: boolean;
  hasError: boolean;
  today: Date;
  onSaveMealPlan: (date: Date, recipeId: string | null, compositionId?: string | null, mealType?: MealType) => void;
  onRemoveMealPlan: (mealPlanId: string) => void;
  onSaveMealNote: (date: Date, noteText: string, mealType: 'breakfast' | 'lunch' | 'dinner') => void;
  onRemoveMealNote: (mealNoteId: string) => void;
}

const DateCard: React.FC<DateCardProps> = ({
  date,
  mealPlans = [],
  mealNotes = [],
  recipes,
  compositions = [],
  isLoading,
  isSubmitting,
  hasError,
  today,
  onSaveMealPlan,
  onRemoveMealPlan,
  onSaveMealNote,
  onRemoveMealNote
}) => {
  return (
    <MealPlannerTile
      date={date}
      mealPlans={mealPlans}
      mealNotes={mealNotes}
      recipes={recipes}
      compositions={compositions}
      isLoading={isLoading}
      isSubmitting={isSubmitting}
      hasError={hasError}
      today={today}
      onRemoveMealPlan={onRemoveMealPlan}
      onRemoveMealNote={onRemoveMealNote}
      onSaveMealNote={(noteText, mealType) => onSaveMealNote(date, noteText, mealType)}
      onSaveMealPlan={(recipeId, compositionId, mealType) => onSaveMealPlan(date, recipeId, compositionId, mealType)}
    />
  );
};

export default DateCard;
